import { FormActivityLogApiResponse } from '@features/forms/types/formActivityLogApi';

interface FilterMockActivityLogParams {
  page?: number;
  limit?: number;
}

export const filterMockActivityLog = (
  response: FormActivityLogApiResponse,
  params: FilterMockActivityLogParams
): FormActivityLogApiResponse => {
  const page = params.page ?? 0;
  const limit = params.limit ?? 10;
  const start = page * limit;
  const data = response.data.slice(start, start + limit);
  const totalRows = response.data.length;

  return {
    data,
    pagination: {
      page,
      limit,
      total_rows: totalRows,
      last_page: start + limit >= totalRows
    }
  };
};

export default filterMockActivityLog;
